import React from 'react';
import {
  Box, Typography, Stack,
} from '@mui/material';
import moment from 'moment';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { convertMoney } from '@/utils/convertMoney';
import Head from 'next/head';
import { style } from '@/styles/globals';
import { styled } from '@mui/system';
import { pr } from '@/utils/pxToRem';
import { lunarYear } from '@/utils/seoHelper';

const REG = /from_name|to_name|luna_year|route_now|latest_pickup_time|earliest_pickup_time|min_fare|route_airline|route_name|average_duration|company|min_price_time/gi;
interface CollapseProps {
  sxWrapper?: {
    [key: string]: any
  },
  data: any,
  idComponent: string | undefined,
  routeName: string,
  startPointHome: any,
  toPointHome: any,
  titleComponent: string,
  dataObj?: any,
  airlines?: string[]
  metaJson: string,
  company?: string;
  minPriceTime?: string;
  isDesktop?: boolean;
  heightDivider?: string
}

const StyledDivider = styled<any>('div')`
  height: ${(props) => props.height || '8px'};
  background: ${style.color.white2};
  width: calc(100% + 32px);
  margin-left: -16px !important;
`;
const StyledDividerDesktop = styled('div')`
  height: 24px;
  background: ${style.color.white2};
  width: calc(100% + 48px);
  margin-left: -24px !important;
`;

export default function CollapseComponent(props: CollapseProps) {
  const {
    sxWrapper, data, titleComponent, idComponent, routeName = '', toPointHome, dataObj, airlines = [], startPointHome, metaJson, company, minPriceTime,
    isDesktop, heightDivider,
  } = props;

  const params: { [key: string]: any } = {
    luna_year: lunarYear,
    route_now: moment().format('DD/MM/YYYY'),
    from_name: startPointHome?.location,
    to_name: toPointHome?.location,
    min_fare: convertMoney(dataObj?.lowest_price || 0),
    latest_pickup_time: dataObj?.latest_pickup_time || '',
    earliest_pickup_time: dataObj?.earliest_pickup_time || '',
    route_airline: airlines?.join(', ') || '',
    route_name: routeName,
    company,
    min_price_time: minPriceTime,
  };
  const replaceContent = (content: string) => content
    .replace(/({{|}})/g, '')
    .replace(REG, (x: string) => params[x] || '');

  return (
    <Stack>
      {isDesktop ? (
        <StyledDividerDesktop />
      ) : (

        <StyledDivider height={heightDivider} />
      )}
      <Box
        sx={{
          ...sxWrapper,
          paddingTop: pr`32`,
        }}
        id={idComponent}
      >
        {!!metaJson && (
        <Head>
          <script type="application/json+ld">
            {replaceContent(metaJson)}
          </script>
        </Head>
        )}
        {!!titleComponent
      && (
      <Typography
        component="h3"
        sx={{
          ...style.text.heading2,
          fontWeight: 500,
        }}
      >
        {replaceContent(titleComponent)}
      </Typography>
      )}
        <Box
          sx={container}
        >
          {data.map((x: any) => (
            <Accordion
              key={x.id}
              id={x.id}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  component="h4"
                  variant="body1"
                >
                  {replaceContent(x.title)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {!!x.content && (
                <Typography
                  component="div"
                  variant="body1"
                  dangerouslySetInnerHTML={{ __html: replaceContent(x.content) }}
                />
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Stack>

  );
}

const container = {
  padding: '16px 0px',
};
